import React from 'react';
import { Grid, Typography } from '@mui/material';
import { createFilterOptions } from '@mui/material/Autocomplete';

/** 가공 제조사 선택과 같은 보조 표기: 사업자번호 (대표명) */
export const gclientAdditionalText = (gclient) => {
  const biz = gclient?.bizRegNumber || '';
  const ceo = gclient?.ceo ? ` (${gclient.ceo})` : '';
  return `${biz}${ceo}`.trim();
};

export const toGclientSelectOption = (gclient) => {
  const name = gclient?.name || '';
  const additional = gclientAdditionalText(gclient);
  return {
    id: gclient?.id,
    name,
    additional,
    label: additional ? `${name}  ${additional}` : name,
    bizRegNumber: gclient?.bizRegNumber,
    ceo: gclient?.ceo,
  };
};

/** 단일 선택 목록. 왼쪽 회사명, 오른쪽 사업자번호 (대표명) */
export const renderGclientOption = (props, option) => (
  <li {...props} key={option.id}>
    <Grid container alignItems="center" wrap="nowrap">
      <Grid item xs={6} sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', pr: 1 }}>
        {option.name}
      </Grid>
      {option.additional ? (
        <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Typography variant="caption" color="text.secondary" noWrap>
            {option.additional}
          </Typography>
        </Grid>
      ) : null}
    </Grid>
  </li>
);

/** 선택된 입력칸에는 회사명만 보인다. */
export const gclientOptionLabel = (option) => option?.name || '';

/** 검색은 회사명, 사업자번호, 대표자를 본다. */
export const filterGclientOptions = createFilterOptions({
  stringify: (option) => option?.label || option?.name || '',
});
